// @flow

/**
 * Module dependencies.
 */

import { colors, units } from 'client/styles';
import { compose } from 'recompose';
import { translator } from 'core/utils';
import Content from 'client/components/content';
import Expanding from 'client/components/licensed-representatives/expanding';
import GetInTouch from 'client/components/licensed-representatives/get-in-touch';
import Header from 'client/components/header';
import PageContent from 'client/components/core/page-content';
import React, { Component } from 'react';

/**
 * `Props` type.
 */

type Props = {
  translate: Function
};

/**
 * Export `LicensedRepresentatives`.
 */

class LicensedRepresentatives extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { translate } = this.props;

    const itemsList = [
      translate('licensedRepresentatives.list.item1'),
      translate('licensedRepresentatives.list.item2'),
      translate('licensedRepresentatives.list.item3')
    ];

    const successContent = {
      buttonThemeColor: colors.brandSecondary,
      message: translate('licensedRepresentatives.form.success.message'),
      renderIcon: false
    };

    return (
      <PageContent background={colors.shadesOfSand2.pampasDarker}>
        <Header
          filename={'licensed-header'}
          short
          title={translate('licensedRepresentatives.title')}
        />

        <Content
          paddingVertical={units(0)}
          pullTop
          separator
        >
          <Expanding
            text={translate('licensedRepresentatives.text')}
            title={translate('licensedRepresentatives.lead')}
          />
        </Content>

        <GetInTouch
          backgroundImage={'building'}
          formSubmitLabel={translate('licensedRepresentatives.form.submit')}
          formTitle={translate('licensedRepresentatives.form.title')}
          list={itemsList}
          reason={'license_representatives'}
          successContent={successContent}
          title={translate('licensedRepresentatives.list.title')}
        />
      </PageContent>
    );
  }

}

/**
 * Export `LicensedRepresentatives` component.
 */

export default compose(
  translator()
)(LicensedRepresentatives);



// WEBPACK FOOTER //
// ../src/client/containers/licensed-representatives/index.js